export default __webpack_public_path__ + "img/8e3cdb6391c02489ffe6af02de66dc7a.png";